import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { I18NextModule } from 'angular-i18next';
import { ButtonModule, MbsSize, ModalComponent, ModalModule } from 'mbs-ui-kit';

@Component({
  selector: 'mbs-tfa-require-modal',
  templateUrl: './tfa-require-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, RouterModule, ModalModule, ButtonModule, I18NextModule]
})
export class TFARequireModalComponent implements OnInit {
  public readonly MbsSize = MbsSize;
  public actionName = 'Remote Management';
  public isVerb = false;

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  ngOnInit(): void {
    this.actionName = this.baseModal?.data?.actionName;
    this.isVerb = this.baseModal?.data?.isVerb ?? false;
  }

  handleClose(): void {
    this.baseModal.close();
  }
}
